import { styled } from '@mui/material';
import { isDesktop } from '@shared/constants/media-queries';
import Text from '@components/Text';

export const ItemWithLabelWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'compactBottom',
})<{ compactBottom?: boolean }>(({ compactBottom }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  marginBottom: compactBottom ? 0 : 0,
  minWidth: 0,
}));

export const ItemTitle = styled(Text)(
  {
    margin: 0,
    display: 'block',
    textTransform: 'uppercase',
    fontSize: 12,
  },
  ({ theme }) => ({
    color: theme.palette.novotalk.$textColorDisabled,
  }),
);
